import { httpClient } from 'shared/services/http/httpClient';
import { RateFastUpdateFormType } from '../components/rateFastUpdateForm/RateFastUpdateFormType';
import {
  rateBuilder,
  RateModel,
  RateModelCRUD,
  ratePartialBuilder,
  RatePartialModel
} from '../models/RateModel';
import { PricePerClientFiltersFormType } from 'app/viaje/viajeTraslado/statistics/types/pricePerClient';

const useRate = () => {
  function create(rate: RateModelCRUD) {
    return httpClient.post(`rates`, rateBuilder.toBackEnd(rate));
  }
  function edit(rate: RateModelCRUD) {
    return httpClient.put(`rates/${rate.id}`, rateBuilder.toBackEnd(rate));
  }
  function onDeleteRate(id: string) {
    return httpClient.delete(`business-clients/rates/${id}`);
  }
  async function getAllByClient(
    clientBusinessId: number
  ): Promise<RatePartialModel[]> {
    const res = await httpClient.get(
      `business-clients/${clientBusinessId}/rates`
    );
    return res.map(ratePartialBuilder.fromBackEnd);
  }

  async function getAllCurrentRates(
    page: number,
    rowsPerPage: number,
    sortBy: string,
    sortDir: string,
    filters: PricePerClientFiltersFormType
  ): Promise<{ data: RateModel[], total: number }> {
    const params = new URLSearchParams();
    if (page !== null) params.append('page', String(page));
    // if (rowsPerPage !== null && rowsPerPage !== 0) params.append('perPage', String(rowsPerPage));
    if (sortBy !== null) params.append('sort', String(sortBy));
    if (sortDir !== null) params.append('dir', String(sortDir));
    if (filters.search !== null)
      params.append('search', String(filters.search));
    const res = await httpClient.get(
      `/business-clients/current-rates?${params.toString()}`
    );
    const rawRates = Array.isArray(res?.data)
      ? res.data
      : Array.isArray(res)
        ? res
        : res
          ? [res]
          : [];
    const data = rawRates.map(rateBuilder.fromBackEnd);
    const total = Number(
      res?.meta?.total ??
      res?.total ??
      rawRates.length
    );
    return { data, total };
  }

  async function get(id: number): Promise<RateModel> {
    const res = await httpClient.get(`rates/${id}`);
    return rateBuilder.fromBackEnd(res);
  }

  const rateFastUpdate = (
    values: RateFastUpdateFormType & { clientId: number }
  ) =>
    httpClient.post(`business-clients/${values.clientId}/rates/fast-store`, {
      expiration_date: values.expirationDate.format('YYYY-MM-DD'),
      percentage: values.porcentage
    });

  return {
    create,
    getAllByClient,
    getAllCurrentRates,
    get,
    edit,
    onDeleteRate,
    rateFastUpdate
  };
};

export default useRate;
